import React from "react";
import GraphImg from "graphcms-image";

const ImageSlide = ({ image, alt }) => {
  return (
    <GraphImg
      style={{
        width: "100%",
        minHeight: "100%",
        objectFit: "cover",
        transition: "0.5s all ease-out",
        zIndex: -1
      }}
      withWebp
      image={image}
      max-width={2000}
      alt={alt}
    />
  );
};

export default ImageSlide;



// WEBPACK FOOTER //
// ./src/components/Carousel/ImageSlide.js